'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { useEffect } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Label } from '@/components/ui/label';
import { useGenerateCountry } from '@/store/generate';
import { useUserCountryQuery } from '@/queries/country-code';
import { COUNTRIES_DATA } from '@/lib/constants/countries';
export const getCountryDisplay = value => {
  const country = COUNTRIES_DATA.find(c => c.code === value);
  return country ? `${country.emoji} ${country.name}` : value;
};
export function CountrySelect() {
  const $ = _c(22);
  const {
    data: fetchedCountryCode
  } = useUserCountryQuery();
  const [open, setOpen] = React.useState(false);
  const {
    country: countryValue,
    setCountry
  } = useGenerateCountry();
  let t0;
  let t1;
  if ($[0] !== countryValue || $[1] !== fetchedCountryCode || $[2] !== setCountry) {
    t0 = () => {
      if (!countryValue && fetchedCountryCode) {
        setCountry(fetchedCountryCode);
      }
    };
    t1 = [fetchedCountryCode, countryValue, setCountry];
    $[0] = countryValue;
    $[1] = fetchedCountryCode;
    $[2] = setCountry;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  const selectedCountryDetails = COUNTRIES_DATA.find(c => c.code === countryValue);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Label htmlFor="country-combobox-button" className="mb-1.5 block text-sm font-semibold text-gray-700">Country</Label>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = selectedCountryDetails ? `${selectedCountryDetails.emoji} ${selectedCountryDetails.name}` : "Select Country...";
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronsUpDown className="ml-2 size-4 shrink-0 opacity-50" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== open || $[8] !== t3) {
    t5 = <PopoverTrigger asChild={true}><Button id="country-combobox-button" variant="outline" role="combobox" aria-expanded={open} className="h-10 w-full justify-between rounded-lg px-3 py-2 font-normal shadow-none hover:bg-white" aria-label="Select country">{t3}{t4}</Button></PopoverTrigger>;
    $[7] = open;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: "var(--radix-popover-trigger-width)"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CommandInput placeholder="Search country..." />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CommandEmpty>No country found.</CommandEmpty>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== countryValue || $[14] !== setCountry) {
    t9 = COUNTRIES_DATA.map(country => <CommandItem key={country.code} value={country.code} keywords={[country.name, country.emoji]} onSelect={() => {
      setCountry(country.code);
      setOpen(false);
    }}><Check className={cn("mr-2 h-4 w-4", countryValue === country.code ? "opacity-100" : "opacity-0")} />{country.emoji} {country.name}</CommandItem>);
    $[13] = countryValue;
    $[14] = setCountry;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <PopoverContent className="w-full p-0" style={t6}><Command>{t7}<CommandList>{t8}<CommandGroup>{t9}</CommandGroup></CommandList></Command></PopoverContent>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== open || $[19] !== t10 || $[20] !== t5) {
    t11 = <div className="w-full">{t2}<Popover open={open} onOpenChange={setOpen}>{t5}{t10}</Popover></div>;
    $[18] = open;
    $[19] = t10;
    $[20] = t5;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}